export const googlePlaceImage = (name?: string) => ['placeImage', name] as const
